import { SET_CURRENT_USER } from './types';

export const currentUserReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
